import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { SingleCard } from './layouts';
import { Landing, 
  LoginForm,
  AccountVerification,
  Confirmation, 
  ResetPasswordForm, 
  ChangePasswordForm, 
  CreateAccountForm, 
  Welcome,
  TermsOfService,
  PrivacyPolicy,
  AboutUs 
} 
from './components';

export default function () {
  return (
    <Switch>
     <Route exact path='/'>
         <Landing/>
     </Route>
      <Route exact path='/login' >
        <SingleCard title="Sign In">
          <LoginForm />
        </SingleCard>
      </Route>
      <Route exact path='/create-account' >
        <SingleCard title="Sign Up">
          <CreateAccountForm />
        </SingleCard>
      </Route>
      <Route exact path='/confirmation/:token'>
          <Confirmation/>
      </Route>
      <Route exact path='/account' render={(props) => <AccountVerification {...props}/>}/>
      <Route exact path='/reset-password' >
        <SingleCard
          title="Reset Password"
          description="Please enter the email address that you used to register, and we will send you a link to reset your password via Email."
        >
          <ResetPasswordForm />
        </SingleCard>
      </Route>
      <Route exact path='/change-password/:recoveryCode' >
        <SingleCard title="Change Password">
          <ChangePasswordForm />
        </SingleCard>
      </Route>
      <Route exact path='/legal/terms-of-service'>
        <TermsOfService/>
      </Route>
      <Route exact path='/legal/privacy-policy'>
        <PrivacyPolicy/>
      </Route>
      <Route exact path='/about-us'>
        <AboutUs/>
      </Route>
      <Redirect to={'/login'} />
    </Switch>
  );
}
